import guestLineup from './guest';
import homeLineup from './home';

export {default as homeLineup} from './home';
export {default as guestLineup} from './guest';

export const getLineupByName = (direction, name) => {
    const lineups = direction === 'up' ? homeLineup : guestLineup;
    return lineups.find(l => l.name === name);
};